export default function studentLearningTasks(
  state = {
    units: undefined,
    loadingErrorMessage: undefined,
    studentDetails: null,
    displayUnitIndex: 0,
    chapters: [],
  },
  action,
) {
  switch (action.type) {
    case 'LEARNING/STUDENT_UNITS_POPULATE':
      return {
        ...state,
        units: action.data,
      };

    case 'LEARNING/STUDENT_LEARNING_TASKS_ERROR_SET':
      return {
        ...state,
        loadingErrorMessage: action.message,
      };

    case 'LEARNING/POPULATE_LEARNING_TASKS_STUDENT_DETAILS':
      return {
        ...state,
        studentDetails: action.studentDetails,
      };

    case 'LEARNING/STUDENT_DISPLAY_UNIT_INDEX_UPDATE':
      return {
        ...state,
        displayUnitIndex: action.index,
      };
    case 'LEARNING/POPULATE_CHAPTERS':
      return {
        ...state,
        chapters: action.chapters || [],
      };
    default:
      return state;
  }
}
